import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=59bb31d6&"
import script from "./ProductSelect.vue?vue&type=script&lang=ts&"
export * from "./ProductSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59bb31d6')) {
      api.createRecord('59bb31d6', component.options)
    } else {
      api.reload('59bb31d6', component.options)
    }
    module.hot.accept("./ProductSelect.vue?vue&type=template&id=59bb31d6&", function () {
      api.rerender('59bb31d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/ProductSelect.vue"
export default component.exports